import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '@local/common';
import { isEmbed, isExtension, isNativeWindow } from '@local/common-web';
import { UiIconModel } from '@local/ui-infra';
import { EmbedService } from '@shared/embed.service';
import { BrowserExtensionService } from '@shared/services/browser-extension.service';

export interface goLinkStep {
  title: string;
  subTitle: string;
  icon: UiIconModel;
}

@Component({
  selector: 'go-links-empty-state',
  templateUrl: './go-links-empty-state.component.html',
  styleUrls: ['./go-links-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoLinksEmptyStateComponent implements OnInit {
  readonly GO_LINKS_STEPS: goLinkStep[] = [
    {
      title: 'Create',
      subTitle: 'Create short and memorable links to find </br> common resources',
      icon: {
        type: 'img',
        value: {
          lightUrl: './assets/go-links/go-links-empty-light-left.svg',
          darkUrl: './assets/go-links/go-links-empty-dark-left.svg',
        },
      },
    },
    {
      title: 'Open everywhere',
      subTitle: 'Quickly open the link in your browser by typing </br> go/link into the address bar',
      icon: {
        type: 'img',
        value: {
          lightUrl: './assets/go-links/go-links-empty-light-right.svg',
          darkUrl: './assets/go-links/go-links-empty-dark-right.svg',
        },
      },
    },
  ];
  isNative: boolean = false;
  isEmbedFromExtension: boolean = false;
  private readonly isEmbed = isEmbed();
  private readonly isExtension = isExtension();

  @Output() onCreateNewGoLink: EventEmitter<void> = new EventEmitter<void>();
  @Input() isLauncher: boolean;

  constructor(
    private embedService: EmbedService,
    private extService: BrowserExtensionService
  ) {}

  ngOnInit() {
    this.isNative = isNativeWindow();
    this.isEmbedFromExtension = this.isEmbed && this.isExtension;
  }

  createNewGoLink(): void {
    this.onCreateNewGoLink.emit();
  }

  downloadExtension() {
    window.open(Constants.DOWNLOAD_EXTENSION, '_blank');
  }

  get showDownloadExtension(): boolean {
    return !this.isEmbedFromExtension && (!this.extService.connected || this.isNative || this.isLauncher);
  }
}
